<template>
    <div>
        <v-row v-if="showAdminUI">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12"><v-btn @click="allUploadToBitrix" color="info" :disabled="countNoBitrixFiles() < 1">Перенести фото в новое облако</v-btn></v-col>
                    <v-col cols="12" v-if="allconverted > 0">{{ converted }}/{{ allconverted }}</v-col>
                </v-row>
            </v-col>
        </v-row>
      <v-row>
        <v-col cols="3" sm="6" md="2" xl="2" v-for="(image, index) in imageSource" v-if="!!imageCheck(image.name, image.type) && image.file !== ''" :key="image.itemKey">
          <v-img :src="image.src" :data-source="image.src"  :aspect-ratio="1" @click="showFileDialog(index)" contain>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0 grey lighten-1" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div class="text-center" v-if="showAdminUI">
            <v-btn v-if="image.src.indexOf('fit-service-bitrix') < 0" small icon @click="uploadToBitrix(image.src, image.name, image, true)" title="Загрузить в битрикс" class="mr-2 ml-2"><v-icon small>mdi-upload</v-icon></v-btn>
            <v-btn small icon @click="deleteImage(image.itemKey)" title="Удалить" class="mr-2 ml-2"><v-icon small>mdi-delete</v-icon></v-btn>
          </div>
        </v-col>
      </v-row>
        <v-col cols="12" v-if="!showUK && stage !== 'C30:2' && stage !== 'C30:WON'">
            <v-row>
                <v-col cols="4"><v-file-input v-model="newPhotoFiles" multiple placeholder="Загрузить фото"></v-file-input></v-col>
                <v-col cols="4"><v-btn color="success" :disabled="newPhotoFiles.length < 1" @click="loadPhoto">Загрузить</v-btn></v-col>
            </v-row>
        </v-col>
        <simple-loader-dialog text="Загрузка..." :show="showLoader"></simple-loader-dialog>
    </div>

</template>

<script>
  import moment from 'moment'
  import SimpleLoaderDialog from '../simpleLoaderDialog'
  export default {
    name: 'tpMediaImages',
    components: { SimpleLoaderDialog },
    props: ['value', 'mode', 'stage'],
    data() {
      return {
        newPhotoFiles: [],
        showLoader: false,
        converted: 0,
        allconverted: 0,
        images: this.value,
        options: {
          inline: false,
          button: true,
          navbar: true,
          title: false,
          toolbar: true,
          tooltip: false,
          movable: true,
          zoomable: true,
          rotatable: true,
          scalable: false,
          transition: false,
          fullscreen: false,
          keyboard: true,
        }
      }
    },
    computed: {
      showAdminUI() {
        if(this.mode) {
          return this.mode !== 'uk' && this.mode !== 'franch' && this.mode !== 'account'
        } else {
          return true
        }
      },
      showUK() {
        return this.mode === 'uk'
      },
      imageSource() {
        if(this.images) {
          return this.images.map(image => {
            image.src = (image.file.indexOf('fit-service-bitrix.ru') > -1) ? image.file : `https://sbotapi.fitauto.ru/v15/shopper/viewfile/${image.file}`
            return image
          })
        } else {
          return []
        }

      },
    },
    methods: {
      loadOne: async function (File) {
        let formData = new FormData()
        let uploadURL, field

        this.showLoader = true
        try {
          const r = await this.$http.post(`${this.$store.getters.bxapi}disk.folder.uploadfile?id=80614`)
          if(r.data.result) {
            uploadURL = r.data.result.uploadUrl
            field = r.data.result.field
            formData.append(field, File, `${moment().format('x')}${File.name}`)
          }
        } catch (e) {
          console.log('e', e)
        }

        if(field !== undefined) {
          try {
            const r = await this.$http.post(uploadURL,
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            )
            this.images.push({
              file: r.data.result.DOWNLOAD_URL,
              name: r.data.result.NAME,
              type: 'image',
              itemKey: `${this.images.length}_${moment().format('x')}`
            })

          } catch (e) {
            console.log(e)
          }
        }
        this.showLoader = false
      },
      loadPhoto: async function () {
        console.log('this fiels', this.newPhotoFiles)
        for(let file of this.newPhotoFiles) {
          await this.loadOne(file)
        }
        console.log('result upload', this.images)
        this.change()
        this.newPhotoFiles = []
      },
      countNoBitrixFiles: function () {
        let images = []

        console.log(this.images || []);

        for(let image of (this.images || [])) {
          if(!!this.imageCheck(image.name, image.type) && image.file !== '') {
            if(image.file.indexOf('fit-service-bitrix') < 0) images.push(image)
          }
        }
        return images.length
      },

      allUploadToBitrix: async function () {
        let images = []
        for(let image of this.images) {
          if(!!this.imageCheck(image.name, image.type) && image.file !== '') {
            if(image.file.indexOf('fit-service-bitrix') < 0) images.push(image)
          }
        }
        this.allconverted = images.length
        for(let image of images) {
          let url = `https://sbotapi.fitauto.ru:3000/v15/shopper/viewfile/${image.file}`
          await this.uploadToBitrix(url, image.name, image)
          this.converted += 1
        }

        this.$nextTick(function () {
          this.change()
          this.allconverted = 0
          this.converted = 0
        })

      },

      uploadToBitrix: async function (url, name, fileData, loadOne = false) {
        this.showLoader = true
        try {
          console.log('data', {url, name, fileData})
          const r = await this.$http.post(`${this.$store.getters.api}v4/media/upload/image`, {
            url: url,
            detail: name
          })
          console.log('converted', r.data)
          if(r.data.error) {
            console.log('Ошибка конвертации файла: ' + r.data.error)
          } else {
            this.images.push({
              file: r.data.result.DOWNLOAD_URL,
              name: r.data.result.NAME,
              type: 'image',
              itemKey: `${this.images.length }_${moment().format('x')}`
            })
            this.deleteImageWOSave(fileData.itemKey)
          }

        } catch (e) {
          console.log(e)
        }
        if(!!loadOne) this.change()
        this.showLoader = false
      },
      deleteImageWOSave(itemKey) {
        let key = -1
        for(let i in this.images) {
          console.log('iter', i, itemKey, this.images[i].itemKey)
          if(this.images[i].itemKey === itemKey) {
            key = i
            break
          }
        }
        if(key > -1) {
          console.log('delete', key, this.images[key])
          this.images.splice(key, 1)
        }
      },
      deleteImage(itemKey) {
        this.showLoader = true
        let key = -1
        for(let i in this.images) {
          console.log('iter', i, itemKey, this.images[i].itemKey)
          if(this.images[i].itemKey === itemKey) {
            key = i
            break
          }
        }
        if(key > -1) {
          console.log('delete', key, this.images[key])
          this.images.splice(key, 1)
          this.$nextTick(function () {
            this.change()
          })
        }
        this.showLoader = false
      },
      imageCheck(filename, type) {
        let types = ['jpg', 'png', 'gif']
        let fname = filename.split('.')
        let sname = fname[fname.length - 1].toLowerCase()
        return (types.indexOf(sname) > -1 || type === 'image')
      },
      showFileDialog (index) {
        // this.$viewer.show()
        this.$viewerApi({
          images: this.imageSource,
          options: {
            ...this.options,
            initialViewIndex: index || 0,
          }
        })
      },
      change () {
        this.$emit('input', this.images)
        this.$nextTick(function () {
          this.$emit('change')
        })
      },

    },
    mounted () {
      console.log('imagez', this.images)
    }
  }
</script>

<style scoped>
    li.viewer-play.viewer-play viewer-large {
        display: none;
    }
</style>
